document.addEventListener('DOMContentLoaded', function() {
  $('.c-testimonials-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    appendDots: $('.testimonials-dots'),
    prevArrow: $('.testimonials-prev'),
    nextArrow: $('.testimonials-next'),
    infinite: false,
    autoplay: false,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  // Custom Social Slider
  $('.custom-social-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  // Mandatory Checkbox Validation for Shop Pay
  function handleMandatoryCheckbox() {
    const mandatoryCheckboxes = document.querySelectorAll('input[name="mandatory_agreement"]');
    const shopPayButtons = document.querySelectorAll('[data-testid="ShopifyPay-button"], .shopify-payment-button, [data-shopify-button]');
    
    mandatoryCheckboxes.forEach(function(checkbox) {
      function toggleShopPayButtons() {
        const isChecked = checkbox.checked;
        
        shopPayButtons.forEach(function(button) {
          if (isChecked) {
            button.style.pointerEvents = 'auto';
            button.style.opacity = '1';
            button.disabled = false;
            if (button.querySelector('button')) {
              button.querySelector('button').disabled = false;
            }
          } else {
            button.style.pointerEvents = 'none';
            button.style.opacity = '0.5';
            button.disabled = true;
            if (button.querySelector('button')) {
              button.querySelector('button').disabled = true;
            }
          }
        });
      }
      
      // Initial state
      toggleShopPayButtons();
      
      // Listen for changes
      checkbox.addEventListener('change', toggleShopPayButtons);
    });
  }
  
  // Run on page load
  handleMandatoryCheckbox();
  
  // Run when new content is loaded (for quick buy drawer)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Check if mandatory checkbox was added
        const hasMandatoryCheckbox = Array.from(mutation.addedNodes).some(function(node) {
          return node.nodeType === 1 && (
            node.querySelector && node.querySelector('input[name="mandatory_agreement"]') ||
            node.matches && node.matches('input[name="mandatory_agreement"]')
          );
        });
        
        if (hasMandatoryCheckbox) {
          setTimeout(handleMandatoryCheckbox, 100);
        }
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});